import { Loader2, Send } from 'lucide-react'
import type { KeyboardEvent, RefObject } from 'react'
import { Button } from '~/components/ui/button'
import { Label } from '~/components/ui/label'
import { Textarea } from '~/components/ui/textarea'
import type { PendingClarification } from './types'

/** 변경 내용 또는 추가 확인 답변을 입력하고 전송하는 필드. */
export function ChangeDescriptionField({
    description,
    pendingClarification,
    followUpMode,
    submitting,
    textareaRef,
    onDescriptionChange,
    onDescriptionKeyDown,
}: {
    description: string
    pendingClarification: PendingClarification | null
    followUpMode: boolean
    submitting: boolean
    textareaRef: RefObject<HTMLTextAreaElement | null>
    onDescriptionChange: (value: string) => void
    onDescriptionKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void
}) {
    return (
        <div className='space-y-1.5'>
            <Label htmlFor='mt-desc'>
                {pendingClarification
                    ? '추가 확인 답변'
                    : followUpMode
                      ? '후속 질문 또는 추가 정보'
                      : '변경 내용'}
            </Label>
            <div className='grid grid-cols-[minmax(0,1fr)_auto] items-end gap-2 max-sm:grid-cols-1'>
                <Textarea
                    ref={textareaRef}
                    id='mt-desc'
                    value={description}
                    onChange={(e) => onDescriptionChange(e.target.value)}
                    onKeyDown={onDescriptionKeyDown}
                    rows={2}
                    placeholder={
                        pendingClarification
                            ? '위 질문에 답해 주세요. 예: 조리장 안 싱크대 옆에 설치하고, 급수·배수에 연결해 식기 세척에 쓸 예정입니다.'
                            : followUpMode
                              ? '이 변경건에 대해 이어서 물어보거나, 추가 정보를 입력해 주세요. Enter로 전송'
                              : '변경 내용을 편하게 적어 주세요. Enter로 전송, Shift+Enter로 줄바꿈'
                    }
                    required
                    className='rounded-sm'
                />
                <Button
                    type='submit'
                    disabled={submitting || !description.trim()}
                    className='h-11 rounded-sm'>
                    {submitting ? (
                        <>
                            <Loader2 className='animate-spin' />
                            {followUpMode
                                ? '반영 중'
                                : pendingClarification
                                  ? '분석 중'
                                  : '확인 중'}
                        </>
                    ) : (
                        <>
                            {pendingClarification ? '답변 보내기' : '보내기'}
                            <Send />
                        </>
                    )}
                </Button>
            </div>
        </div>
    )
}
